import LocationAdapter from 'shared/location_adapter';
import KidsMode from 'commons/KidsMode/KidsMode';
import AhoyEvent from 'shared/ahoy_event';

export default class KidsToggle {
  constructor({ element: $element }){
    this.element = $element;
    this.locationAdapter = new LocationAdapter();
  }

  init() {
    this.activateKidsMode();
  }

  activateKidsMode() {
    this.element.addEventListener('click', ()=> {
      KidsMode.activate();
      this.sendActivatedKidsModeEvent();
      LocationAdapter.href('/kids');
    });
  }

  sendActivatedKidsModeEvent() {
    AhoyEvent.send('VIDIO::KIDS_MODE', {action: 'activated', source: 'menu option'});
  }
}
